<template>
	<div id="Jobretument" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/qzzp.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/qzzp_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>求职</span><span style="color:#D7230C;">招聘</span></div>
					<div class="sm_pub">海量职位/人才</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/Jobrecruitmentdetails">
				查看更多&nbsp;>
			</router-link>
		</div>
		<div class="Jobcenter" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);">
			<!-- 上 -->
			<div class="JobcenterTop">
				<div class="JobcenterTop_bulo"></div>
				<div class="JobcenterTop_red"></div>
				<div class="JobcenterTop_centent">
					<router-link tag="div" :to="{ path:'/Jobrecruitmentdetailss'}" class="JobcenterTop_centent_left">
						更多简历
					</router-link>
					<router-link tag="div" :to="{ path:'/Jobrecruitmentdetails'}"  class="JobcenterTop_centent_left Jobmlft">
						更多职位
					</router-link>
				</div>
				<div class="JobcenterTop_red"></div>
				<div class="JobcenterTop_bulo"></div>
			</div>
			<!-- 下 -->
			<div class="JobcenterBottom">
				<!-- 左 -->
				<div class="JobcenterBottom_left">
					<ul>
						<router-link tag="li" :to="{ path:'/qzzpdetailist',query:{id:item,title:item.title} }"  v-for="(item,index) in xptjlist" :key="index">
							<div class="JobcenterBottom_left_L">
								<img style="width: 100%;height: 100%;" v-lazy="item.picture" alt="">
							</div>
							<div class="JobcenterBottom_left_R">
								<div>年龄：{{item.age}}</div>
								<div v-if="item.xueli == '本科'">学历:本科</div>
								<div v-if="item.xueli == '专科'">学历:专科</div>
								<div v-if="item.xueli == '硕士'">学历:硕士</div>
								<div v-if="item.xueli == '博士'">学历:博士</div>
								<div v-if="item.xueli == '无需求'">学历:无需求</div>
								<div style="">专业：{{item.zhuanye}}</div>
							</div>
						</router-link>
					</ul>
				</div>
				<!-- 右 -->
				<div class="JobcenterBottom_right">
					<router-link tag="div" :to="{ path:'/qzzpdetail',query:{id:item.id,title:item.title} }"  class="JobcenterBottom_right_div" v-for="(item,index) in gonglist" :key="index">
						<div style="height: 130px;">
							<img v-lazy="item.qiye_img" style="width: 100%;height: 100%;" alt="">
						</div>
						<div class="JobBottomSb">
							{{item.title}}
						</div>
						<div class="JobBottomSe">
							工作经验:{{item.jobexperience}}
						</div>
						<div class="JobBottom_bo">
							<!-- 左、 -->
							<div class="JobBottom_bo_L">
								<img v-lazy="item.zhanshi_img" style="width: 100%;height: 100%;" alt="">
							</div>
							<!-- 右 -->
							<div class="JobBottom_bo_R">
								{{item.enterprise}}
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: '',
				gonglist: ''
			}
		},
		methods: {

		},
		async mounted() {
			let res = await http.post('api/Common/index', {
				model: 'hr',
				type: 'content',
				mid: '10'
			})
			this.xptjlist = res.data.data.list.data
			console.log(this.xptjlist)
			let res1 = await http.post('api/Common/index', {
				model: 'hr',
				type: 'content',
				mid: '9',
				rows_limit: '8'
			})
			this.gonglist = res1.data.data.list.data
		}
	}
</script>

<style>
	#Jobretument {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	.Jobcenter {
		width: 100%;
		height: 590px;
		margin-top: 20px;
	}

	.JobcenterTop {
		width: 100%;
		height: 75px;
	}

	.JobcenterBottom {
		width: 100%;
		margin-top: 10px;
		height: 500px;
	}

	.JobcenterTop_centent {
		width: 20%;
		height: 75px;
		float: left;

		margin-left: 1%;
	}

	.JobcenterTop_bulo {
		width: 18%;
		height: 37.5px;
		float: left;
		border-bottom: 2px dashed rgb(26, 182, 245);
		margin-left: 1%;
	}

	.JobcenterTop_red {
		width: 19%;
		height: 37.5px;
		float: left;
		border-bottom: 2px dashed rgb(240, 10, 87);
		margin-left: 1%;
	}

	.Jobmlft {
		margin-left: 4%;
	}

	.JobcenterBottom_left>ul {
		padding: 0px;
		margin: 0px;
	}


	.JobcenterBottom_left>ul>li {
		width: 100%;
		height: 90px;
		color: #fff;
		float: left;
		margin-top: 10px;
		box-sizing: border-box;
		border-radius: 5px;
		border: 1px solid rgb(211, 211, 211);
	}

	.JobcenterTop_centent_left {
		width: 48%;
		height: 55px;
		margin-top: 10px;
		background-color: rgb(215, 35, 32);
		float: left;
		letter-spacing: 4px;
		text-align: center;
		font-size: 18px;
		line-height: 55px;
		font-weight: 600;
		color: #fff;
		cursor: pointer;
	}

	.JobcenterBottom_left {
		width: 20%;
		height: 500px;
		float: left;
		overflow: scroll;
	}

	.JobcenterBottom_right {
		width: 78%;
		height: 500px;
		float: left;
		margin-left: 2%;
	}


	.JobcenterBottom_left::-webkit-scrollbar {
		display: none;
	}

	.JobcenterBottom_left_L {
		width: 60px;
		height: 70px;
		margin-top: 10px;
		margin-left: 10px;
		float: left;
		cursor: pointer;
	}

	.JobcenterBottom_left_R {
		float: left;
		width: 125px;
		font-size: 12px;
		line-height: 27px;
		margin-left: 20px;
		height: 70px;
		margin-top: 5px;
		color: #000;
		cursor: pointer;
	}

	.JobcenterBottom_right_div {
		height: 230px;
		margin-top: 15px;
		width: 21%;
		margin-left: 3%;
		float: left;
		border: 1px solid #ececec;
		box-sizing: border-box;
		border-radius: 10px;
	}

	.JobBottomSb {
		font-size: 15px;
		font-weight: 600;
		margin-left: 5px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	.JobBottomSe {
		height: 30px;
		margin-left: 5px;
		line-height: 30px;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		font-size: 14px;
	}
	
	.JobBottom_bo{
		height: 45px;
		width: 100%;
	}
	
	.JobBottom_bo_L{
		width: 35px;
		height: 35px;
		border-radius: 50%;
		margin-top: 5px;
		margin-left: 5px;
		float: left;
		overflow: hidden;
	}
	.JobBottom_bo_R{
		float: left;
		width: 130px;
		margin-top: 5px;
		height: 35px;
		line-height: 35px;
		margin-left: 10px;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 14px;
		display: -webkit-box;
	}
</style>
